import React from 'react'
import GoogleMapReact from 'google-map-react'
import { FaMapMarkerAlt } from 'react-icons/fa'

const MapMarker = () => (
  <div
    style={{
      width: 42,
      height: 42,
      lineHeight: 0,
      transform: 'translate(-50%, -100%)'
    }}
  >
    <FaMapMarkerAlt size='42' color='#222' />
  </div>
)

const GoogleMap = (content, { lat, lng, zoom }) => (
  <GoogleMapReact
    bootstrapURLKeys={{
      key: process.env.GATSBY_GOOGLE_MAP_KEY
    }}
    defaultCenter={{
      lat: content.content.lat || lat,
      lng: content.content.lng || lng
    }}
    defaultZoom={content.content.zoom || zoom}
  >
    <MapMarker
      lat={content.content.lat || lat}
      lng={content.content.lng || lng}
    />
  </GoogleMapReact>
)

GoogleMap.defaultProps = {
  lat: 59.95,
  lng: 30.33,
  zoom: 12
}

export default GoogleMap
